import React, { useMemo } from "react";
import "../assets/guardianStatusOverview.css";

const STATUS_CARDS = [
  { key: "all", label: "ALL", color: "#B75555", statusIds: [] }, // Will be calculated
  { key: "documents_required", label: "Documents Required", color: "#993399", statusIds: [2] },
  { key: "documents", label: "Documents Uploaded", color: "#79629F", statusIds: [11] },
  { key: "vetted", label: "Vetted", color: "#48E38C", statusIds: [12] },
  { key: "payment", label: "Payment Pending", color: "#EDAB95", statusIds: [4] },
  {
    key: "awaiting_collection",
    label: "Awaiting Key Collection",
    color: "#855C33",
    statusIds: [5]
  },
  { key: "placed", label: "Placed", color: "#47478D", statusIds: [6] },
  { key: "black_listed", label: "Blacklisted", color: "#FF3333", statusIds: [8] },
  { key: "Not_Interested", label: "Not Interested", color: "#85D6FF", statusIds: [9] },
  { key: "NTQ", label: "NTQ", color: "#ADADAD", statusIds: [10] },
  { key: "previous_guardian", label: "Previous Guardian", color: "#855C33", statusIds: [7] },
  { key: "archived", label: "Archived", color: "#EDAB95", statusIds: [13] },
];

const GuardianStatusOverview = ({
  guardianStatuses,
  guardiansCount,
  selectedStatus,
  selectedStatusCard,
  onStatusClick,
}) => {
  const getTotalCount = () => {
    return Object.values(guardiansCount).reduce((sum, count) => sum + count, 0);
  };

  const getCountForCard = (card) => {
    if (card.key === "all") {
      return getTotalCount();
    }
    
    // Sum up counts for all status IDs associated with this card
    return card.statusIds.reduce((sum, statusId) => {
      return sum + (guardiansCount[statusId] || 0);
    }, 0);
  };

  const handleStatusClick = (cardKey) => {
    console.log('🔍 Guardian status card clicked:', cardKey);

    // Find the card to get its status IDs
    const card = STATUS_CARDS.find(c => c.key === cardKey);

    if (cardKey === "all") {
      // Clear all filters when "ALL" is clicked
      onStatusClick("", "");
    } else if (card && card.statusIds.length > 0) {
      // Always apply the filter (no toggle - user expects consistent filter behavior)
      const statusId = card.statusIds[0];
      onStatusClick(statusId, cardKey);
    } else {
      // For cards without specific status IDs, use the card key
      onStatusClick(cardKey, cardKey);
    }
  };

  return (
    <div className="row">
      <div className="col-md-12">
        <div className="panel-group mb-20 border-down">
          <div className="users-overview-title">
            <h3>Guardians overview</h3>
          </div>
          <div className="panel-body" style={{border: 'none'}}>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: 10,
                alignItems: "flex-start",
                justifyContent: "flex-start",
                overflow: "hidden",
              }}
            >
              {STATUS_CARDS.map((card) => (
                <div className="ticket-overview-container" key={card.key}>
                  <div className="ticket-overview-row">
                    <div
                      className={`ticket-overview-card ${selectedStatusCard === card.key ? 'active' : 'all-active'}`}
                      style={{
                        background: card.color,
                        cursor: "pointer",
                      }}
                      onClick={() => handleStatusClick(card.key)}
                    >
                      <div className="ticket-overview-value">
                        {getCountForCard(card)}
                      </div>
                      <div className="ticket-overview-label text-white overview-label" style={{textAlign: 'center'}}>
                        {card.label}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GuardianStatusOverview;
